import { render } from "./LoadingModal.vue?vue&type=template&id=049aa30e&scoped=true"
import script from "./LoadingModal.vue?vue&type=script&lang=js"
export * from "./LoadingModal.vue?vue&type=script&lang=js"

import "./LoadingModal.vue?vue&type=style&index=0&id=049aa30e&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\PeD\\WebCNCMonitor\\dashboard\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049aa30e"]])

export default __exports__